
import { FaBookOpen, FaBookmark, FaFacebookF, FaHospital } from "react-icons/fa6"
import { BsInstagram, BsYoutube } from "react-icons/bs"
import PopUp from "./popUp";
const HealthAndWellness = () => {
    const points = [
        {
            title: "Individual Guidance & Counselling (I&C)",
            paragraph: `Volunteer or referred cases (personal, academic, finance or career). Counselors at Universiti Tenaga Nasional conduct confidential and personalized counseling sessions, analyzing students' needs through interviews and providing necessary assistance.`
        },
        {
            title: "Group Guidance & Counseling (G&C)",
            paragraph: `Volunteer or referred cases (personal, academic, finance or career).`
        },
        {
            title: "Consultation (Personal, Academic & Work)",
            paragraph: `Parents, guardians, G&C trainees and UNITEN staffs. The Guidance and Counselling Unit at Universiti Tenaga Nasional supports students facing academic challenges, guidance on career planning and personalized counselling sessions.`
        },
        {
            title: "Other Programs",
            paragraph: `Short course / seminar / workshop on G&C, mentoring, motivation, self-esteem, personality and personal development.`
        },
    ]
    const cards = [
        {
            icon: <FaHospital size={30} />,
            title: "Personal Counselling",
            description: `Counsellors will conduct counselling and guidance sessions for students in a confidential manner.`
        },
        {
            icon: <FaBookmark size={30} />,
            title: "Academic Counselling",
            description: `Academic matters such as course choice, study plan and learning support.`
        },
        {
            icon: <FaBookOpen size={30} />,
            title: "Career Counselling",
            description: `Students may need guidance and advice on career planning.`
        },
    ]
    const socialIcons = [
        {
            icon: <FaFacebookF />,
            text: 'Facebook',
        },

        {
            icon: <BsInstagram />,
            text: 'Instagram',
        },
        {
            icon: <BsYoutube />,
            text: 'Youtube',
        },
    ]
    const contacts = [
        {
            location: "Putrajaya campus",
            info: [
                {
                    name: "Mrs. Razana",
                    mobile: "+603-89287168"
                }
            ]

        },
        {
            location: "kshas campus",
            info: [
                {
                    name: "FATONAH BT MOHD ZAIDI",
                    mobile: "+03-89212020 ext 7591"
                },
                {
                    name: "PN. NUR ADILAH MOHD HAMZAH",
                    mobile: "+603-8921 2020 ext 5025"
                },
            ],

        },
        {
            location: "Level 4, Counselling Unit, UNITEN KSHAS",
            info: [
                {
                    name: "MOHD HAFIS BIN MOHAMAD",
                    mobile: "+609-455 2020 ext 3174, +6013-6009 737",
                    email: "mhafis@uniten.edu.my"
                },
            ],

        },
    ]
    const title = "hospitals & clinic"
    const heading = "Health and wellness"
    const description = `Universiti Tenaga Nasional offers confidential counseling for all students, addressing a range of issues like anxiety, sadness, and relationship problems. The service provides a safe, impartial space for students seeking support independently of family or friends.`
    const img = `https://lh3.googleusercontent.com/p/AF1QipNio1H1xyi4hkBJEsXXEM3UQFT0uMi2EtI1hQPg=s680-w680-h510`
    return (
        <PopUp
            heading={heading}
            title={title}
            description={description}
            img={img} points={points}
            cards={cards}
            socialIcons={socialIcons}
            contacts={contacts} />
    )
}

export default HealthAndWellness